import { InjectionToken } from "@angular/core";
import { environment } from "../../environments/environment";

export const BASE_SERVICE_CONFIG_INJECTION_TOKEN = new InjectionToken<
	BaseServiceConfig
>("base-service-config", {
	providedIn: "root",
	factory: () =>
		<BaseServiceConfig>{
			apiEndpoint: environment.apiEndpoint
		}
});

export class BaseServiceConfig {
	apiEndpoint: string;
}
